import React from "react";
import Select from "react-select";
import {
    Label,
} from "reactstrap";

const SelectBox = ({ options, selectionChange, width, label }) => {
    const customStyles = {
        dropdownIndicator: base => ({
            ...base,
            background: "var(--base-color-dark-blue)",
        }),
        control: base => ({
            ...base,
            borderRadius: 0,
            width: width ?? 100
        })
    };

    return (
        <>
            {label && (
                <Label for="NumberOfDevices" className="mr-2 mt-1">
                    {label}
                </Label>
            )}
            <Select styles={customStyles} onChange={selectionChange} options={options} />

        </>
    )
}

export default SelectBox;